import { Component, OnInit, ViewEncapsulation, HostListener,  ViewChild, TemplateRef } from '@angular/core';
import { trigger,  state,  style, transition, animate } from '@angular/animations';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Observable, Subscriber, Subscription} from 'rxjs/Rx';
import { UsersService } from 'src/app/services/users.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService , UsersService],
  animations: [
    trigger('showInfo', [
      state('1' , style({ transform: 'rotate(180deg)' })),
      state('0', style({ transform: 'rotate(0deg)' })),
      transition('1 => 0', animate('400ms')),
      transition('0 => 1', animate('400ms'))
    ])
  ]
})
export class HeaderComponent implements OnInit {
  public showHorizontalMenu:boolean = true; 
  public showInfoContent:boolean = false;
  public settings: Settings;
  public menuItems:Array<any>;
  public modalRef: NgbModalRef;

  header_subscriber : Subscription;
  @ViewChild('modalVersion', {static: false}) modalVersion: TemplateRef<any>;

  
  constructor(public appSettings:AppSettings, public menuService:MenuService, private router:Router,
    public  localStorageService: LocalStorageService, public svc_user : UsersService, private modal: NgbModal) {
      this.settings = this.appSettings.settings;
      this.menuItems = this.menuService.horizontal_menu_items;
  }
  
  ngOnInit() {
    this.local_version = this.localStorageService.get('version');
    
    if(window.innerWidth <= 768) {
      this.showHorizontalMenu = false;
    }

    const header_observable = Observable.interval(7200000)//every 2 hours;
		this.header_subscriber = header_observable.subscribe(x => {
			this.checkOfUpdatedVersion();
		});
  }
  
  ngOnDestroy() {
		this.header_subscriber.unsubscribe();
    clearInterval(this.queue_data);
  }

  public closeSubMenus(){
    let menu = document.querySelector("#menu0"); 
    if(menu){
      for (let i = 0; i < menu.children.length; i++) {
          let child = menu.children[i].children[1];
          if(child){          
              if(child.classList.contains('show')){            
                child.classList.remove('show');
                menu.children[i].children[0].classList.add('collapsed'); 
              }             
          }
      }
    }
  }

  @HostListener('window:resize')
  public onWindowResize():void {
     if(window.innerWidth <= 768){
        this.showHorizontalMenu = false;
     }      
      else{
        this.showHorizontalMenu = true;
      }
  }

  public local_version = '';
  public new_version = '';
  public logout_count = 20;
  public logout_counter :any;

  interval;
  queue_data :any;
  checkOfUpdatedVersion(){
    this.svc_user.getVersion().subscribe(data=>{
      this.local_version = this.localStorageService.get('version');
      
      this.new_version = data["tms_version"];
      console.log('checking version :', this.local_version, this.new_version);
      if(this.new_version != '' && this.new_version != this.local_version){
        
        //open modal
        this.modalRef = this.modal.open(this.modalVersion, {container: '.app', backdrop: 'static', size: 'md'});

        //refresh
        this.logout_counter = setInterval(() => {
          this.logout_count--;
          if(this.logout_count == 0){
            clearInterval(this.logout_counter);
          }
        },1000)

        this.queue_data = setInterval(() => {;this.refresh();},20000)
        
      };
    });
  }

  refresh(){
    console.log('logging out...');
    this.modalRef.close();
    this.header_subscriber.unsubscribe();
    this.router.navigate(['logout']);
  }
  
}
